
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { useToast } from "primevue/usetoast";
import router from "@/router";
import { useCurrentTime } from "../pages/useCurrentTime";


export default {
  props: {
    isLoggedIn: {
      type: Boolean,
      required: true
    }
  },
  setup(props) {
    const store = useStore();
    const toast = useToast();
    const permission = ref('');


    const homeMenu = computed(() => {
      const menu = ref([
        {
          label:'Trang chủ',
          icon:'pi pi-fw pi-home',
          to: '/'
        },
        {
          label:'Thống kê bệnh nhân',
          icon:'pi pi-fw pi-users',
          to: '/thongkebenhnhan'
        },
        {
          label:'Thống kê doanh thu',
          icon:'pi pi-fw pi-dollar',
          to: '/thongkedoanhthu'
        },
        {
          label:'Thống kê trực tuyến',
          icon:'pi pi-fw pi-sync',
          to: '/thongtintructuyen'
        },
        {
          label:'Đăng ký tài khoản',
          icon:'pi pi-fw pi-user-plus',
          to: '/registerPage'
        },
        {
          label:'Quản lý tài khoản',
          icon:'pi pi-fw pi-users',
          to: '/userList'
        },
      ]);
      const menuKT = ref([
        {
          label:'Trang chủ',
          icon:'pi pi-fw pi-home',
          to: '/'
        },
        {
          label:'Thống kê doanh thu',
          icon:'pi pi-fw pi-dollar',
          to: '/thongkedoanhthu'
        },
      ]);
      const menuKP = ref([
        {
          label:'Trang chủ',
          icon:'pi pi-fw pi-home',
          to: '/'
        },
        {
          label:'Thống kê bệnh nhân',
          icon:'pi pi-fw pi-users',
          to: '/thongkebenhnhan'
        },
      ]);
      // return menu.value;
      console.log("###########@@@@@@@@@@ check menu store.state.token: " + store.state.token);
      console.log("###########@@@@@@@@@@ check menu store.state.permission: " + store.state.permission);
      if(!!store.state.token) {
        console.log("###########@@@@@@@@@@ check menu store.state.permission: " + store.state.permission);
        if((store.state.permission == 'admin'))
        {
          permission.value = 'admin';
          console.log("###########@@@@@@@@@@ check menu admin: ");
          return menu.value;
        }
        else if(store.state.permission == 'ketoan')
        {
          permission.value = 'ketoan';
          console.log("###########@@@@@@@@@@ check menu ketoan: ");
          return menuKT.value;
        }
        else if(store.state.permission == 'khoaphong')
        {
          permission.value = 'khoaphong';
          console.log("###########@@@@@@@@@@ check menu khoaphong: ");
          return menuKP.value;
        }
        else
        return [];
      }
      else
        return [];
    })

    const logout = () => {
      store.dispatch('clearToken');
      store.dispatch('clearPermission');
      router.push({
        name: 'login',
      });
      toast.add({
        severity:'success',
        summary: 'Đăng xuất',
        detail:'Đã xóa thông tin đăng nhập thành công',
        life: 1000
      });
    }
    const { currentTime } = useCurrentTime();
    console.log(currentTime.value);

    return {
      homeMenu,
      logout,
      currentTime,
      permission
    }
  }
}
